import React from 'react';
import {FormattedMessage} from 'react-intl';

import Utility from '../../utils/Helper';
import Config from '../../utils/Configuration';
import decorateContainer from '../../utils/DecoratedContainer';
import i18nLabels from './GlobalMessage.i18n';

const handleCarePageLinkClick = () => {
    throw new Error('Not implement');
};

// const handleMainPageLinkClick = () => {
//     throw new Error('Not implement');
// };

const handleClickEvent = (errorCode) => {
    throw new Error('Not implement');
};

const UpdateEmailAndRedoReservation = ({intl, i18nLabels}) => {
    return (
        <div className='text-black'>
            <FormattedMessage
                {...i18nLabels.missingCustomerEmailOrderHelpText}
                values={{
                    maxisCare: (
                        <span onClick={handleCarePageLinkClick} className='cursor-pointer text-underline'>
                            {intl.messages.maxisCare}
                        </span>
                    )
                }}
            />
        </div>
    );
};

const GlobalErrorMessage = ({intl, i18nLabels, errorCode}) => (
    <FormattedMessage
        {...(i18nLabels[errorCode] || i18nLabels[Config.errorCodeKeyList.defaultCodeForUndefinedError])}
        values={{
            here: (
                <span onClick={() => handleClickEvent(errorCode)} className='cursor-pointer text-underline'>
                    {intl.messages.hereLabel}
                </span>
            ),
            now: (
                <span onClick={() => handleClickEvent(errorCode)} className='cursor-pointer text-underline'>
                    {intl.messages.nowLabel}
                </span>
            ),
            careHere: (
                <span onClick={handleCarePageLinkClick} className='cursor-pointer text-underline'>
                    {intl.messages.hereLabel}
                </span>
            ),
            notAvailable: <span className='maxis-extraBold'>{intl.messages.notAvailable}</span>,
            onYourWay: <span className='maxis-extraBold'>{intl.messages.onYourWay}</span>,
            chatNow: (
                <span
                    onClick={() => Utility.whatsAppUsNow(Config.whatsAppMessageTemplate.mosDevicePurchaseInterest)}
                    className='cursor-pointer text-underline'
                >
                    {intl.messages.chatNowLabel}
                </span>
            ),
            whatsAppChatNow: (
                <span
                    onClick={() => Utility.whatsAppUsNow(Config.whatsAppMessageTemplate.roiKnowMoreOffer)}
                    className='cursor-pointer text-underline'
                >
                    {intl.messages.chatNowLabel}
                </span>
            ),
            hotlinkOrderTrackingUrl: (
                <span
                    onClick={() => Utility.openExternalLink(Config.apiConfig.hotlinkOrderTracking)}
                    className='cursor-pointer text-underline'
                >
                    {intl.messages.hereLabel}
                </span>
            ),
            missingCustomerEmailOrderHelpText: <UpdateEmailAndRedoReservation intl={intl} i18nLabels={i18nLabels} />,
            br: <br />,
            back: (
                <span className='cursor-pointer text-underline' onClick={window.history.goBack}>
                    {intl.messages.backLabel}
                </span>
            ),
            chat: (
                <span
                    onClick={() => Utility.whatsAppUsNow(Config.whatsAppMessageTemplate.tacInvalidGenericInput)}
                    className='cursor-pointer text-underline'
                >
                    {intl.messages.chat}
                </span>
            )
        }}
    />
);

export default decorateContainer(GlobalErrorMessage, i18nLabels);
